module.exports = __webpack_public_path__ + "static/bg04-438bafeb56ad813c425a0419ca794019.jpg";